import _typeof from "./typeof.js";
export default function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/toPrimitive.js
// module id = 1789
// module chunks = 0